import {
  CartItemLegacyGroupEnum,
  CartItemTypeEnum,
} from '@sola/schema/dotcom/cart/cart-item.ts';
import type { CartItem } from '@sola/schema/dotcom/cart/cart-item.ts';
import { SponsorshipItemTypeEnum } from '@sola/schema/dotcom/cart/sponsorship.ts';

// map sponsorship type to the group in legacy for analytics reporting.
export const mapSponsorshipTypeToLegacyGroup = (
  sponsorshipType?: SponsorshipItemTypeEnum,
): CartItemLegacyGroupEnum => {
  switch (sponsorshipType) {
    case SponsorshipItemTypeEnum.Selected: {
      return CartItemLegacyGroupEnum.ChildSelected;
    }
    case SponsorshipItemTypeEnum.EPayment: {
      return CartItemLegacyGroupEnum.EPayment;
    }
    case SponsorshipItemTypeEnum.FirstPayment: {
      return CartItemLegacyGroupEnum.FirstPayment;
    }
    case SponsorshipItemTypeEnum.LongestWaiting: {
      return CartItemLegacyGroupEnum.LongestWaiting;
    }
    case SponsorshipItemTypeEnum.ChildCriteria: {
      return CartItemLegacyGroupEnum.ChildCriteria;
    }
  }

  return CartItemLegacyGroupEnum.ChildSelected;
};

/**
 * Maps the cart item type to a cart item group.
 * @param item The cart item data.
 */
export const mapCartItemTypeToLegacyGroup = (
  item: Partial<CartItem>,
): CartItemLegacyGroupEnum => {
  switch (item.itemType) {
    case CartItemTypeEnum.Sponsorship: {
      return mapSponsorshipTypeToLegacyGroup(
        item?.sponsorship?.sponsorshipType,
      );
    }
    case CartItemTypeEnum.Payment: {
      return CartItemLegacyGroupEnum.CommitmentPayment;
    }
    case CartItemTypeEnum.Gift: {
      return CartItemLegacyGroupEnum.GiftPayment;
    }
    case CartItemTypeEnum.Fund: {
      return CartItemLegacyGroupEnum.Fund;
    }
  }

  return CartItemLegacyGroupEnum.Fund;
};
